var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"parallaxy_image"}},[_c('parallax',{attrs:{"speedFactor":0.35,"direction":"down"}},[_c('img',{attrs:{"src":require("@/assets/imgs/home-header-bg.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }